<template>
  <div class="main_view">
    <div class="login">
      <div class="mylogin" style="vertical-align: middle; text-align:center;">
        <h2>袤周-大数据智慧种草平台</h2>
        <h4>账号登录</h4>
        <el-form
          :model="loginForm"
          :rules="loginRules"
          ref="loginForm"
          label-width="0px"
        >
          <el-form-item label="" prop="account" style="margin-top: 10px">
            <el-row>
              <el-col :span="2">
                <span class="el-icon-s-custom"></span>
              </el-col>
              <el-col :span="22">
                <el-input
                  class="inps"
                  placeholder="账号"
                  v-model="loginForm.account"
                >
                </el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="" prop="passWord">
            <el-row>
              <el-col :span="2">
                <span class="el-icon-lock"></span>
              </el-col>
              <el-col :span="22">
                <el-input
                  class="inps"
                  type="password"
                  placeholder="密码"
                  v-model="loginForm.passWord"
                ></el-input>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item style="margin-top: 55px">
            <el-button type="primary" round class="submitBtn" @click="submitForm">登录</el-button>
          </el-form-item>
          <div class="unlogin">
            <a href="http://h5.wushangxianzhi.com/xfx_service" target="_blank" style="color: #999; text-decoration:underline" >获取体验账号</a>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { Base64 } from 'js-base64';
import process from "shelljs";
export default {
  name: "BigdataLogin",
  data() {
    return {
      loginForm: {
        account: "",
        passWord: "",
      },
      loginRules: {
        account: [{required: true, message: "请输入账号", trigger: "blur"}],
        passWord: [{required: true, message: "请输入密码", trigger: "blur"}],
      }
    }
  },
  methods: {
    submitForm() {
      const userAccount = this.loginForm.account;
      const userPassword = this.loginForm.passWord;
      if (!userAccount) {
        return this.$message({
          type: "error",
          message: "账号不能为空！",
        })
      }
      if (!userPassword) {
        return this.$message({
          type: "error",
          message: "密码不能为空！",
        })
      }
      let sendTime = moment(new Date()).format("YYYYMMDDHHssmm");
      let sign = Base64.encode('maoyan2020' + sendTime);
      let base = '/api';
      if (process.env.NODE_ENV === "development") {
        base = 'http://api.wushangxianzhi.com';
      }
      let url = '/api/v2/maocep/maocep_user_login';
      this.$axios({
        method: 'post',
        url: `${base}${url}`,
        responseType: 'json',
        contentType: 'application/json',
        data: JSON.stringify({
          'sign': sign,
          'phone': userAccount,
          'password': userPassword,
        })
      }).then((res) => {
        console.log("success: ", res)
        // 本地保存token
        this.$cookies.set("UserToken",res.data.result[0].token,'7d')
        this.$cookies.set("UserName",res.data.result[0].nickname,'7d')
        this.$cookies.set("KeyWord",res.data.result[0].analysis_keywords,'7d')
        // 跳转
        this.$router.push('/bigdata')
      }).catch((res) => {
        console.log("error: ", res);
      })
    }
  },
  metaInfo: {
    title: "袤-AI数据挖掘系统",
    meta: [
      { name: "viewport", content: "width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0" },
      { name: "keywords", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "description", content: "袤周-大数据驱动下的智慧种草平台" },
      { name: "format-detection", content: "telephone=no,email=no" }
    ],
    link: [{
      rel: 'shortcut icon',
      href: '/static/favicon.ico'
    }]
  }
}
</script>


<style scoped lang="stylus" rel="stylesheet/stylus">
@import '../comm/css/base.styl'
.login
  width 100vw
  padding 0
  margin 0
  height 100vh
  font-size 16px
  background-position left top
  background-color #242645
  color #fff
  position relative
  .mylogin
    width 300px
    height 350px
    position absolute
    top 0
    left 0
    right 0
    bottom 0
    margin auto
    padding 50px 40px 40px 40px
    box-shadow -15px 15px 15px rgba(6, 17, 47, 0.7)
    opacity 1
    background linear-gradient(230deg, rgba(53, 57, 74, 0) 0%, rgb(0, 0, 0) 100%)
  .inps input
    border none
    color #fff
    background-color transparent
    font-size 12px
  .submitBtn
    width 200px

</style>




// WEBPACK FOOTER //
// src/components/bigdata/BigdataLogin.vue